import { render } from "./PortalRegister.vue?vue&type=template&id=77a8da51&scoped=true&ts=true"
import script from "./PortalRegister.vue?vue&type=script&lang=ts"
export * from "./PortalRegister.vue?vue&type=script&lang=ts"

import "./PortalRegister.vue?vue&type=style&index=0&id=77a8da51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a8da51"]])

export default __exports__